import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_PhotoToIllustration = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/photo-to-illustration',
			name: 'Turn Photo Into Illustration – AI Converter Online | Lift',
			description:
				"Make illustration from photo instantly with Lift's AI Photo to Illustration Converter. No drawing skills needed, no watermark Upload a photo, apply a style, and get artistic results perfect for avatars, posts, or prints.",
			url: 'https://liftapp.ai/photo-to-illustration',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/photo-to-illustration#product' },
				{ '@id': 'https://liftapp.ai/photo-to-illustration#howto' },
				{ '@id': 'https://liftapp.ai/photo-to-illustration#benefits' },
				{ '@id': 'https://liftapp.ai/photo-to-illustration#faq' },
				{ '@id': 'https://liftapp.ai/photo-to-illustration#why-lift' },
				{ '@id': 'https://liftapp.ai/photo-to-illustration#explore-tools' },
				{ '@id': 'https://liftapp.ai/photo-to-illustration#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/photo-to-illustration#product',
			name: 'AI Photo to Illustration Converter',
			description:
				"Turn your photos into artistic illustrations instantly with Lift's AI Photo to Illustration Converter. No drawing skills needed — perfect for avatars, social posts, and prints.",
			url: 'https://liftapp.ai/photo-to-illustration',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/photo-to-illustration#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose an illustration style',
					text: 'Pick your favorite illustration style — from clean lines to artistic looks',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'AI transforms your photo',
					text: 'Our AI redraws your photo as an illustration in seconds',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and share',
					text: 'Save your illustration or share it directly to social media',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-illustration#benefits',
			name: 'Who can benefit from AI Photo to Illustration Converter?',
			description:
				"Lift's AI Photo to Illustration Converter is ideal for social media users, creators, and anyone who wants artistic avatars and posts without learning to draw.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social media enthusiasts can stand out with artistic avatar illustrations and unique posts',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators can quickly generate scroll-stopping visuals that boost engagement',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Personal brands can create distinctive profile pictures that show off their creative side',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'People without design skills can still get professional-looking illustrations in seconds',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Anyone who wants quick, creative, premium-quality visuals for fun or projects',
				},
			],
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/photo-to-illustration#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo to Illustration Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Photo to Illustration Converter is an online tool that transforms your photos into artistic illustrations instantly — perfect for social media avatars, creative posts, personalized gifts, or unique digital art.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift turn photos into illustrations?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo using advanced deep learning, identifies key features and composition, then reimagines it in illustration style with artistic lines, colors, and effects. Everything is automatic — no manual drawing or editing skills required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I convert any photo into an illustration?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift works with portraits, selfies, group photos, pets, landscapes, and any image type. The AI adapts to your photo's content and applies illustration transformations that maintain recognizable features while adding artistic flair.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the illustration without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All illustrations created in Lift can be exported without a watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, printing, framing, or any creative project.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-illustration#why-lift',
			name: 'Why Lift’s AI Photo to Illustration Converter stands out',
			description:
				"Lift's Photo to Illustration tool combines high-quality AI rendering, ease of use, and cross-platform access — making it the perfect choice for creative visuals.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool.',
				},
			],
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-illustration#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/photo-to-illustration#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Photo to Illustration',
					item: 'https://liftapp.ai/photo-to-illustration',
				},
			],
		},
	],
};
